import { cdnTemplate, jadeLocals } from 'cdnPreprocessor';
import Analytics from '../../analytics';

export default [
  '$state', 'CartService',
  function stripePayment($state, cart, analytics = new Analytics()) {
    return {
      restrict: 'E',
      template: require('./stripe-payment.jade')(jadeLocals),
      link: (scope) => {
        scope.stripeCheckout = () => {
          cart.triggerInitiateCheckout();
          analytics.checkout({ option: 'CreditCard', cart: cart.contentsAsCampaignProducts() });

          let slugs = cart.slug().split('/');
          $state.go('checkout', { pn: slugs[0], sl: slugs[1] });
        }
      }
    }
  }
]



// WEBPACK FOOTER //
// ./source/client/layout-components/stripe-payment/stripe-payment.dir.js